export default __webpack_public_path__ + "static/media/ic_bal_40.92c38673.svg";